import { store } from '../../redux/store';

interface GetCurrentPositionAsyncProps {
  requestPermission?: boolean;
  options?: PositionOptions;
  onResolve?: PositionCallback;
  onReject?: PositionErrorCallback;
}
export const getCurrentPositionAsync = ({
  requestPermission = true,
  options,
  onResolve,
  onReject,
}: GetCurrentPositionAsyncProps = {}): Promise<GeolocationPosition | null> => {
  return new Promise<GeolocationPosition | null>((resolve, reject) => {
    // Location saved by the useRealtimeLocation hook in the redux store,
    // this will be updated only with useRealtimeLocation
    const currentLocation = store.getState().locationReducer.location;
    if (currentLocation) {
      onResolve?.(currentLocation);
      resolve(currentLocation);
      return;
    }

    // If the requestPermission is false, or if the navigator API is not available, return null
    if (!requestPermission || typeof navigator === 'undefined' || !navigator.geolocation) {
      resolve(null);
      return;
    }

    // If the location is not available in the redux store, we can use the browser's geolocation API to get the current location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        onResolve?.(position);
        resolve(position);
      },
      (error) => {
        onReject?.(error);
        reject(error);
      },
      options,
    );
  });
};
